export interface GroupedTeamBucket {
  groupId: any;
  groupName: string;
  teams: any[];
}

export interface GroupedTeams {
  networkLabel: string;
  networkTeams: any[];
  groupedTeams: GroupedTeamBucket[];
}

export function groupTeamsByNetwork(teams: any[], groups: any[], networkLabel: string): GroupedTeams {
  const networkTeams: any[] = [];
  const bucketsById = new Map<any, GroupedTeamBucket>();

  (teams || []).forEach((team) => {
    if (!team.networkGroupId) {
      networkTeams.push(team);
      return;
    }
    if (!bucketsById.has(team.networkGroupId)) {
      const group = (groups || []).find((g: any) => g.id == team.networkGroupId);
      bucketsById.set(team.networkGroupId, {
        groupId: team.networkGroupId,
        groupName: group ? (group.network_group_name || group.group_name || group.name) : 'Group',
        teams: [],
      });
    }
    bucketsById.get(team.networkGroupId).teams.push(team);
  });

  return {
    networkLabel,
    networkTeams,
    groupedTeams: Array.from(bucketsById.values()),
  };
}

export function filterTeamGroups(grouped: GroupedTeams, searchTerm: string): GroupedTeams {
  if (!searchTerm || !searchTerm.trim()) {
    return grouped;
  }
  const term = searchTerm.trim().toLowerCase();
  const matchesTeam = (team: any) => (team.name || '').toLowerCase().includes(term);
  const networkMatches = grouped.networkLabel.toLowerCase().includes(term);

  return {
    networkLabel: grouped.networkLabel,
    networkTeams: grouped.networkTeams.filter((team) => networkMatches || matchesTeam(team)),
    groupedTeams: grouped.groupedTeams
      .map((bucket) => {
        const groupMatches = bucket.groupName.toLowerCase().includes(term);
        return {
          ...bucket,
          teams: bucket.teams.filter((team) => groupMatches || matchesTeam(team)),
        };
      })
      .filter((bucket) => bucket.teams.length > 0),
  };
}
